var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 8.47106L46.2668 35.6882L29.6949 0L48 8.47106ZM36.5218 43.6643L24.0002 50.8089L11.4782 43.6643L14.025 37.4921H33.975L36.5218 43.6643ZM24.0002 13.5467L30.5616 29.4984H17.4384L24.0002 13.5467ZM1.71544 35.6882L0 8.47106L18.3051 0L1.71544 35.6882Z",
    fill: "url(#paint0_linear_649_353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 8.47106L46.2668 35.6882L29.6949 0L48 8.47106ZM36.5218 43.6643L24.0002 50.8089L11.4782 43.6643L14.025 37.4921H33.975L36.5218 43.6643ZM24.0002 13.5467L30.5616 29.4984H17.4384L24.0002 13.5467ZM1.71544 35.6882L0 8.47106L18.3051 0L1.71544 35.6882Z",
    fill: "url(#paint1_linear_649_353)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_353",
    x1: 1203.41,
    y1: 4620.01,
    x2: 4690.03,
    y2: 2963.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E40035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F60A48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#F20755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#DC087D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#9717E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_649_353",
    x1: 1049.42,
    y1: 612.654,
    x2: 3433.66,
    y2: 3332.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF31D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5BE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 50.8125,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.ffb267cde62ce9cd6a25b6f84be34cd5.svg";
export { ForwardRef as ReactComponent };